import { Star } from "lucide-react";
import { motion } from "framer-motion";
import { REVIEWS } from "../../data";
import { Reveal } from "./Reveal";

const Stars = () => (
    <div className="flex gap-0.5 text-strawred">
        {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={18} fill="currentColor" strokeWidth={0} />
        ))}
    </div>
);

export const Reviews = () => (
    <section
        id="resenas"
        data-testid="reviews-section"
        className="py-20 md:py-28 px-4"
    >
        <div className="max-w-6xl mx-auto">
            <Reveal className="text-center mb-6">
                <span className="font-label uppercase tracking-[0.25em] text-xs text-strawred font-semibold">
                    Amor de León
                </span>
                <h2 className="mt-3 font-display font-bold text-4xl md:text-6xl text-gradient-pink">
                    Lo que dicen nuestros clientes
                </h2>
            </Reveal>

            <Reveal className="flex justify-center mb-12">
                <div
                    data-testid="google-badge"
                    className="inline-flex items-center gap-3 bg-white rounded-full pl-5 pr-6 py-3 shadow-lg shadow-hotpink/10 border border-pink-50"
                >
                    <span className="font-display font-black text-2xl text-[#1a0a10]">
                        5.0
                    </span>
                    <Stars />
                    <span className="font-label uppercase tracking-wide text-xs font-semibold text-[#6e4b58]">
                        Tienda de Postres · Google
                    </span>
                </div>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {REVIEWS.map((r, i) => (
                    <Reveal key={r.name} delay={i * 0.12}>
                        <motion.div
                            whileHover={{ y: -6 }}
                            data-testid={`review-card-${i}`}
                            className="h-full bg-white rounded-3xl p-7 shadow-xl shadow-hotpink/10 border border-pink-50 flex flex-col"
                        >
                            <Stars />
                            <p className="mt-4 text-[#1a0a10] font-medium leading-relaxed flex-1">
                                "{r.text}"
                            </p>
                            <div className="mt-5 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-hotpink text-white grid place-items-center font-display font-bold">
                                    {r.name[0]}
                                </div>
                                <span className="font-display font-semibold text-[#1a0a10]">
                                    {r.name}
                                </span>
                            </div>
                        </motion.div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
